(function () {
  'use strict';
  if (window.CTCommerceBrief) return;
  var PREFIX = 'ct_brief_v1:';
  var MAX = 100000;
  var TTL = 60 * 60 * 1000;
  var paymentSelector = '[data-ctc-pay-full], [data-ctc-pay-deposit]';
  var groupBindings = new WeakSet();
  function status(anchor, text, error) {
    var parent = anchor && anchor.parentElement || document.body;
    var box = parent.querySelector('[data-ct-brief-status]');
    if (!box) {
      box = document.createElement('p');
      box.dataset.ctBriefStatus = '1';
      parent.appendChild(box);
    }
    box.setAttribute('role', error ? 'alert' : 'status');
    box.textContent = text;
    return box;
  }
  function stringify(value) {
    return JSON.stringify(value, function (key, item) {
      return Object.prototype.toString.call(item) === '[object Set]' ? Array.from(item) : item;
    });
  }
  function valid(value) {
    return value && typeof value === 'object' && !Array.isArray(value) &&
      (Array.isArray(value.travellers) || Number.isFinite(Number(value.travellers))) &&
      Number(Array.isArray(value.travellers) ? value.travellers.length : value.travellers) > 0;
  }
  function go(value, anchor) {
    try {
      if (!valid(value)) throw new Error('brief');
      var record = { version: 1, created: Date.now(), brief: value };
      var raw = stringify(record);
      if (raw.length > MAX) throw new Error('size');
      var id = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
      sessionStorage.setItem(PREFIX + id, raw);
      if (sessionStorage.getItem(PREFIX + id) !== raw) throw new Error('storage');
      window.location.assign('/pages/start-planning?inquiry=' +
        (value.source === 'product-quote' ? 'group' : 'bespoke') + '&brief_id=' + id + '#enquiry');
      return true;
    } catch (error) {
      status(anchor, 'Your brief has not been sent. Keep this page open and try again, or contact hello@chinatourly.com.', true);
      return false;
    }
  }
  function readBrief() {
    var params = new URLSearchParams(window.location.search);
    var id = params.get('brief_id');
    var raw;
    if (id) {
      if (!/^[a-z0-9-]{1,80}$/.test(id)) throw new Error('id');
      raw = sessionStorage.getItem(PREFIX + id);
      if (!raw || raw.length > MAX) throw new Error('missing');
      var saved = JSON.parse(raw);
      if (saved.version !== 1 || Date.now() - saved.created > TTL || saved.created > Date.now() + 60000) throw new Error('expired');
      if (!valid(saved.brief)) throw new Error('invalid');
      return { id: id, brief: saved.brief };
    }
    // Read older links without evaluating or rendering their content as HTML.
    raw = params.get('brief');
    if (raw) {
      if (raw.length > MAX) throw new Error('size');
      var legacy = JSON.parse(raw);
      if (!valid(legacy)) throw new Error('invalid');
      return { id: null, brief: legacy };
    }
    return null;
  }
  var labels = {
    source: 'Request', party: 'Party', travellers: 'Travellers', days: 'Days', pace: 'Pace',
    interests: 'Interests', cities: 'Cities', travelNotes: 'Travel notes', perDay: 'Day-by-day choices',
    defaultHotel: 'Hotel preference', defaultTransport: 'Transport preference', defaultMeal: 'Meal preference',
    itinerary: 'Itinerary', total: 'Builder estimate (not a confirmed quote)', product: 'Journey',
    productUrl: 'Journey URL', dates: 'Requested dates', reason: 'Quote required for',
    age: 'Age', gender: 'Gender', notes: 'Needs', schedule: 'Schedule', activities: 'Activities'
  };
  function describe(value, depth) {
    if (depth > 12) throw new Error('depth');
    if (value == null) return 'Not specified';
    if (typeof value !== 'object') return String(value);
    if (Array.isArray(value)) return value.map(function (item, i) { return (i + 1) + '. ' + describe(item, depth + 1); }).join('\n');
    return Object.keys(value).filter(function (key) { return !['step', 'activeScene'].includes(key); })
      .map(function (key) { return (labels[key] || key) + ': ' + describe(value[key], depth + 1); }).join('\n');
  }
  function setEmpty(form, name, value) {
    var el = form.elements.namedItem(name);
    if (el && !el.value && value != null) el.value = String(value);
  }
  function shortTourContact(form, params) {
    if (params.get('source') !== 'short-tour' || !/^LT0[1-5]$/.test(params.get('tour_id') || '')) return;
    var title = (params.get('tour') || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 200);
    if (!title) return;
    var requested = params.get('date') || '';
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(requested);
    var date = match && new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    var validDate = date && date.getFullYear() === Number(match[1]) &&
      date.getMonth() + 1 === Number(match[2]) && date.getDate() === Number(match[3]);
    var party = /^([1-9]\d?) adults$/.exec(params.get('travellers') || '');
    var adults = party ? Number(party[1]) : null;
    var children = params.get('children') === 'yes';
    var lines = ['Short private tour inquiry', 'Journey: ' + title, 'Route reference: ' + params.get('tour_id')];
    if (validDate) lines.push('Requested date: ' + requested);
    lines.push(adults ? 'Adults: ' + adults : 'Party size: to be confirmed');
    if (children) lines.push('Children also travelling: please confirm their number, heights and bed requirements. The total party size is not yet confirmed.');
    lines.push('Please confirm availability, inclusions and the final party price in writing. This request is not a booking or payment confirmation.');
    setEmpty(form, 'contact[planning_brief]', lines.join('\n'));
    setEmpty(form, 'contact[body]', 'Please review my short-tour request and confirm availability and the final price.');
    setEmpty(form, 'contact[journey_type]', 'Private group quote');
    if (validDate) setEmpty(form, 'contact[dates]', requested);
    if (adults && !children) {
      setEmpty(form, 'contact[travelers]', adults <= 2 ? adults : adults <= 4 ? '3-4' : adults <= 8 ? '5-8' : '9+');
      setEmpty(form, 'contact[traveler_count]', adults);
    }
    // Query values describe a request, never trusted prices or contracted travellers.
    setEmpty(form, 'contact[planning_brief_json]', stringify({
      source: 'short-tour-request', routeReference: params.get('tour_id'), product: title,
      dates: validDate ? requested : '', adults: adults, childrenIncluded: children,
      totalTravellers: children ? null : adults, availability: 'not_confirmed', price: 'not_confirmed'
    }));
  }
  function contact() {
    var form = document.getElementById('ct-inquiry-form-v3');
    if (!form || form.dataset.ctCommerceBound) return;
    form.dataset.ctCommerceBound = '1';
    var params = new URLSearchParams(location.search);
    var id = params.get('brief_id');
    if (form.querySelector('.ct-contact-v3__success')) {
      try {
        id = id || sessionStorage.getItem(PREFIX + 'active');
        if (id && /^[a-z0-9-]{1,80}$/.test(id)) sessionStorage.removeItem(PREFIX + id);
        sessionStorage.removeItem(PREFIX + 'active');
      } catch (error) { /* Receipt remains valid when browser storage is unavailable. */ }
      return;
    }
    var record;
    try {
      record = readBrief();
      if (!record) shortTourContact(form, params);
      // Native POST may return a URL without the original query on validation failure.
      if (!record && form.querySelector('[data-ct-server-errors]')) {
        var active = sessionStorage.getItem(PREFIX + 'active');
        if (active && /^[a-z0-9-]{1,80}$/.test(active)) {
          var saved = JSON.parse(sessionStorage.getItem(PREFIX + active) || 'null');
          if (saved && Date.now() - saved.created < TTL && valid(saved.brief)) record = { id: active, brief: saved.brief };
        }
      }
      if (record) {
        var brief = record.brief;
        var count = Array.isArray(brief.travellers) ? brief.travellers.length : Number(brief.travellers);
        var text = describe(brief, 0);
        var field = form.elements.namedItem('contact[planning_brief]');
        if (field && !field.value) field.value = text;
        setEmpty(form, 'contact[body]', 'Please review my attached planning brief.');
        setEmpty(form, 'contact[travelers]', count <= 2 ? count : count <= 4 ? '3-4' : count <= 8 ? '5-8' : '9+');
        setEmpty(form, 'contact[dates]', brief.dates);
        setEmpty(form, 'contact[journey_type]', brief.source === 'product-quote' ? 'Private group quote' : 'Bespoke planning request');
        var countField = form.elements.namedItem('contact[traveler_count]');
        if (countField) countField.value = count;
        var jsonField = form.elements.namedItem('contact[planning_brief_json]');
        if (jsonField) jsonField.value = stringify(brief);
        if (record.id) sessionStorage.setItem(PREFIX + 'active', record.id);
        status(form.querySelector('button[type="submit"]'), 'Your brief is attached below. Review it and send your inquiry when ready.', false);
      }
    } catch (error) {
      status(form.querySelector('button[type="submit"]'), 'Your saved brief could not be loaded. It has not been sent. Return to the builder or describe your trip below.', true);
    }
    var button = form.querySelector('button[type="submit"]');
    if (!button) return;
    var timer;
    form.addEventListener('submit', function (event) {
      if (!navigator.onLine) {
        event.preventDefault();
        status(button, 'You are offline. Your inquiry has not been sent. Reconnect and try again.', true);
        return;
      }
      if (!form.checkValidity()) return;
      // Keep Shopify's native form and CAPTCHA. Only Liquid confirms receipt.
      status(button, 'Submitting your inquiry. Receipt is not yet confirmed.', false);
      clearTimeout(timer);
      timer = setTimeout(function () {
        status(button, 'Receipt is not yet confirmed. Check the connection or any verification request before trying again.', true);
      }, 20000);
    });
    window.addEventListener('pageshow', function () { clearTimeout(timer); });
  }
function partyDecision(raw, hasChildren, signature, exactDate, today) {
  var quantity = Number(raw);
  var valid = String(raw).trim() !== '' && Number.isSafeInteger(quantity) && quantity > 0;
  var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(exactDate || '');
  var date = match && new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  var dateValid = Boolean(match && date.getFullYear() === Number(match[1]) &&
    date.getMonth() + 1 === Number(match[2]) && date.getDate() === Number(match[3]));
  var now = today || new Date();
  if (dateValid) dateValid = date >= new Date(now.getFullYear(), now.getMonth(), now.getDate());
  var reason = '';
  if (!valid) reason = 'Enter the exact whole number of travellers. No payment is available for an invalid party size.';
  else if (hasChildren) reason = 'Children in the party: confirm each child\'s height and bed arrangement in your quote before payment. No child charge is calculated here.';
  else if (!signature) reason = 'Confirm this journey\'s party size and payment terms in a private quote before payment.';
  else if (signature && (quantity < 4 || quantity > 10)) reason = 'For this Signature journey, parties of 1-3 or 11+ need a private quote before payment.';
  else if (!dateValid) reason = 'Choose a valid future start date or request a planner quote before payment.';
  return { valid: valid, quantity: quantity, dateValid: dateValid, requiresQuote: Boolean(reason), reason: reason };
}

function partyState(root) {
  var input = root.querySelector('[data-ctc-qty]');
  var child = root.querySelector('[data-ctc-children]');
  var parts = ['year', 'month', 'day'].map(function (part) {
    var el = root.querySelector('[data-ctc-' + part + ']');
    return el && el.value ? String(el.value).padStart(part === 'year' ? 4 : 2, '0') : '';
  });
  var result = partyDecision(input && input.value || '', Boolean(child && child.checked),
    root.dataset.ctSignature === 'true', parts.every(Boolean) ? parts.join('-') : '');
  var countInput = root.querySelector('[data-ctc-child-count]');
  if (child && child.checked && countInput && countInput.value !== '') {
    var count = Number(countInput.value);
    if (!Number.isSafeInteger(count) || count < 1 || count > result.quantity) {
      result.valid = false;
      result.requiresQuote = true;
      result.reason = 'The child count must be a whole number between 1 and the total number of travellers.';
    }
  }
  // Recompute from this root's controls; a clone can carry stale data attributes.
  var calendar = window.CTHolidayCalendar;
  var calendarState = calendar && calendar.resolveParts(parts[1], parts[2], parts[0]);
  var calendarQuote = calendarState ? calendarState.quoteRequired : root.dataset.ctCalendarQuote !== undefined;
  if (result.valid && calendarQuote) {
    result.requiresQuote = true;
    result.reason = calendarState && calendarState.note || root.dataset.ctCalendarNote || 'A planner must confirm this date and price before payment.';
  }
  return result;
}

  function groupBrief(root, reason) {
    var input = root.querySelector('[data-ctc-qty]');
    var parts = ['year', 'month', 'day'].map(function (part) {
      var el = root.querySelector('[data-ctc-' + part + ']'); return el && el.value || '';
    });
    return { source: 'product-quote', product: document.querySelector('h1') && document.querySelector('h1').textContent.trim(),
      productUrl: location.origin + location.pathname, travellers: Number(input.value),
      children: { included: Boolean(root.querySelector('[data-ctc-children]') && root.querySelector('[data-ctc-children]').checked),
        count: root.querySelector('[data-ctc-child-count]') && root.querySelector('[data-ctc-child-count]').value || 'Not specified',
        heightAndBed: root.querySelector('[data-ctc-child-notes]') && root.querySelector('[data-ctc-child-notes]').value || 'Planner to confirm' },
      dates: parts.every(Boolean) ? parts.join('-') : '', reason: reason };
  }
  function group(root) {
    if (root.dataset.ctcNoInquiry === 'true') return;
    if (groupBindings.has(root)) return;
    var input = root.querySelector('[data-ctc-qty]');
    if (!input) return;
    groupBindings.add(root);
    root.dataset.ctGroupBound = '1';
    var note = root.querySelector('.ct-commerce-quote') || document.createElement('div');
    note.className = 'ct-commerce-quote';
    var message = note.querySelector('p') || document.createElement('p'); message.setAttribute('role', 'status');
    var quote = note.querySelector('a') || document.createElement('a'); quote.href = '/pages/start-planning?inquiry=group#enquiry';
    quote.textContent = 'Request a private quote';
    quote.className = 'ct-commerce-quote__link';
    note.append(message, quote);
    var anchor = root.querySelector('.ctc-group-note') || input.parentElement;
    anchor.insertAdjacentElement('afterend', note);
    function reason() { return partyState(root).reason; }
    function update() {
      var calendar = window.CTHolidayCalendar;
      if (calendar || root.dataset.ctCalendarQuote !== undefined) {
        var fields = ['month', 'day', 'year'].map(function (part) {
          var field = root.querySelector('[data-ctc-' + part + ']'); return field && field.value || '';
        });
        var resolved = calendar && calendar.resolveParts(fields[0], fields[1], fields[2]);
        var calendarQuote = String(!resolved || Boolean(resolved.quoteRequired));
        var calendarNote = resolved ? resolved.note || '' : 'The annual holiday calendar is unavailable. Request a planner quote before payment.';
        if (root.dataset.ctCalendarQuote !== calendarQuote) root.dataset.ctCalendarQuote = calendarQuote;
        if (root.dataset.ctCalendarNote !== calendarNote) root.dataset.ctCalendarNote = calendarNote;
      }
      var gate = partyState(root);
      var blocked = gate.requiresQuote;
      var childDetails = root.querySelector('[data-ctc-child-details]');
      var childChoice = root.querySelector('[data-ctc-children]');
      if(childDetails) childDetails.hidden = !(childChoice && childChoice.checked);
      root.classList.toggle('ct-requires-quote', blocked);
      note.hidden = !blocked;
      message.textContent = blocked ? gate.reason : '';
      quote.hidden = !gate.valid;
      if (blocked) root.querySelectorAll(paymentSelector).forEach(function (link) {
        if (link.getAttribute('href') !== quote.getAttribute('href')) link.setAttribute('href', quote.getAttribute('href'));
      });
    }
    quote.addEventListener('click', function (e) { e.preventDefault(); if(partyState(root).valid) go(groupBrief(root, reason()), quote); });
    root.addEventListener('input', update); root.addEventListener('change', update);
    root.addEventListener('click', function () { queueMicrotask(update); });
    new MutationObserver(update).observe(root, { subtree: true, attributes: true,
      attributeFilter: ['href', 'data-ct-calendar-quote', 'data-ct-calendar-note', 'data-ct-signature'] });
    update();
  }
  // Capture before legacy payment handlers; old or copied CTA URLs never win this UI gate.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest(paymentSelector);
    var root = link && link.closest('[data-ctc-booking]');
    if (!root) return;
    if (root.dataset.ctcNoInquiry === 'true') return;
    var input = root.querySelector('[data-ctc-qty]'); var n = Number(input && input.value);
    var gate = partyState(root);
    if (gate.requiresQuote) {
      e.preventDefault(); e.stopImmediatePropagation();
      if(!gate.valid) { status(link, gate.reason, true); return; }
      go(groupBrief(root, gate.reason), link);
    }
  }, true);
  window.CTCommerceBrief = { version: '20260908.1', go: go };
  function bindAdded(node) {
    if (node.nodeType !== 1) return;
    if (node.matches('[data-ctc-booking]')) group(node);
    node.querySelectorAll('[data-ctc-booking]').forEach(group);
  }
  new MutationObserver(function (records) {
    records.forEach(function (record) { record.addedNodes.forEach(bindAdded); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  function init() {
    contact(); document.querySelectorAll('[data-ctc-booking]').forEach(group);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
